const comment_old = {
	group: "block",
	content: "block+",
	attrs: { mail: { default: null }, dateTime: { default: null } },
};

export default comment_old;
